document.querySelectorAll('.brand-showcase').forEach(function (section) {
  var wrap = section.querySelector('[data-brand-wrap]');
  var track = section.querySelector('[data-brand-track]');
  if (!track || !wrap) return;

  var cards = Array.from(track.children);
  if (cards.length === 0) return;

  // Kesintisiz döngü için kartları bir kez daha kopyala
  cards.forEach(function (card) {
    track.appendChild(card.cloneNode(true));
  });

  var speedSetting = parseInt(section.dataset.speed, 10);
  var speed = (speedSetting || 3) * 0.25;

  var pos = 0;
  var halfWidth = 0;
  var paused = false;
  var dragging = false;
  var startX = 0;
  var startPos = 0;

  function measure() {
    halfWidth = track.scrollWidth / 2;
  }
  window.addEventListener('load', measure);
  setTimeout(measure, 200);

  function loop() {
    if (!paused && !dragging && halfWidth > 0) {
      pos -= speed;
      if (Math.abs(pos) >= halfWidth) pos = 0;
      track.style.transform = 'translateX(' + pos + 'px)';
    }
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);

  track.addEventListener('pointerdown', function (e) {
    dragging = true;
    paused = true;
    startX = e.clientX;
    startPos = pos;
  });

  window.addEventListener('pointermove', function (e) {
    if (!dragging) return;
    pos = startPos + (e.clientX - startX);
  });

  window.addEventListener('pointerup', function () {
    if (dragging) {
      dragging = false;
      paused = false;
    }
  });

  wrap.addEventListener('mouseenter', function () {
    if (!dragging) paused = true;
  });
  wrap.addEventListener('mouseleave', function () {
    if (!dragging) paused = false;
  });
});